import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneApi } from '../../components/kiene-table/kiene-api';
import { Client, ClientApi } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';

@Injectable()
export class ClientService {
    constructor(
        private readonly http: HttpClient,
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    getAllClients(
        sortColumn: string,
        sortDirection: string,
        offset: number,
        limit: number,
        searchString: string,
        showNewClients: boolean,
    ): Observable<ClientApi> {
        let params = new HttpParams();

        if (sortColumn) {
            let columnAndDirection = sortColumn + ' asc';
            if (sortDirection) {
                columnAndDirection = sortColumn + ' ' + sortDirection;
            }

            params = params.append('orderby', columnAndDirection);
        }

        if (offset) {
            params = params.append('offset', offset.toString());
        }

        if (limit) {
            params = params.append('limit', limit.toString());
        }

        if (searchString) {
            params = params.append('search', searchString);
        }

        if (showNewClients) {
            params = params.append('neukunde', '1');
        }

        return this.http.get<ClientApi>(this.apiBaseUrl + 'kunde/read.php', { params: params });
    }

    getClientById(id: number): Observable<Client> {
        return this.http.get<Client>(this.apiBaseUrl + 'kunde/read_one.php?kunde_id=' + id);
    }

    getClientsByCompanyGroup(companyGroupId: number): Observable<ClientApi> {
        return this.http.get<ClientApi>(this.apiBaseUrl + 'kunde/read.php?unternehmensgruppe_id=' + companyGroupId);
    }

    searchClients(
        searchString: string,
        options?: { onlyActiveClients?: boolean; includeInactive?: boolean },
    ): Observable<ClientApi> {
        let params = new HttpParams().set('limit', '25').set('offset', '0').set('search', searchString ?? '');
        if (options?.onlyActiveClients === true) {
            params = params.set('aktiv', '1');
        }
        if (options?.includeInactive === true) {
            params = params.set('inaktiv', '1');
        }
        return this.http.get<ClientApi>(this.apiBaseUrl + 'kunde/read.php', { params });
    }

    /** Schlanke Suche, nur für Mitarbeiter eines Mandanten. Der Endpunkt antwortet erst ab 2 Zeichen. */
    searchClientsAutocomplete(
        searchString: string,
        options?: { onlyActiveClients?: boolean; includeInactive?: boolean },
    ): Observable<ClientApi> {
        let params = new HttpParams().set('search', searchString ?? '');
        if (options?.onlyActiveClients === true) {
            params = params.set('aktiv', '1');
        }
        if (options?.includeInactive === true) {
            params = params.set('inaktiv', '1');
        }
        return this.http.get<ClientApi>(this.apiBaseUrl + 'kunde_autocomplete/read.php', { params });
    }

    getMandantenForClient(client: Client) {
        if (!client) {
            return undefined;
        }
        const params = new HttpParams().set('kunde_id', client.kunde_id);
        return this.http.get<KieneApi>(this.apiBaseUrl + 'kunde_mandant/read.php', { params: params });
    }
}
